export const CREATE_ACCOUNT_PENDING = "CREATE_ACCOUNT_PENDING";
export const CREATE_ACCOUNT_SUCCESS = "CREATE_ACCOUNT_SUCCESS";
export const CREATE_ACCOUNT_ERROR = "CREATE_ACCOUNT_ERROR";
export const SAVE_PASSWORD = "SAVE_PASSWORD";
export const LOGOUT_USER = "LOGOUT_USER";
export const AUTH_TOKEN = "AUTH_TOKEN";
